import React from "react";

import {
  Stack,
  StackItem,
  Card,
  CardBody
} from "@patternfly/react-core";

import BranchPanel from "./BranchPanel";

const DashboardBranches = ({
  branches,
  isAuthUser,
  themeVersion
}) => {
  const publishedBranches = Object.entries(branches ?? {}).filter(
    ([, branch]) =>
      branch?.organization_branch_published === true
  );

  const showCard = isAuthUser || publishedBranches.length > 1;

  return (
    <Stack hasGutter>
      {publishedBranches.map(([branchNumber, branch]) => {
        const branchPanel = (
          <BranchPanel
            branch={branch}
            isAuthUser={isAuthUser}
            themeVersion={themeVersion}
          />
        );

        return (
          <StackItem key={branchNumber}>
            {showCard ? (
              <Card isCompact>
                <CardBody>
                  {branchPanel}
                </CardBody>
              </Card>
            ) : (
              branchPanel
            )}
          </StackItem>
        );
      })}
    </Stack>
  );
};

export default DashboardBranches;